import Term from 'domains/models/term';
import { z } from 'zod';

export type TermCreateBody = z.infer<typeof schemaTermCreateBody>;
export const schemaTermCreateBody = z.object({
  uid: z.string(),
  name: z.string(),
  description: z.string(),
});

export type TermUpdateBody = z.infer<typeof schemaTermUpdateBody>;
export const schemaTermUpdateBody = z.object({
  name: z.string(),
  description: z.string(),
});

export type TermCreateResult = z.infer<typeof schemaTermCreateResult>;
export const schemaTermCreateResult = z.object({
  id: z.number(),
});

export type TermItem = z.infer<typeof schemaTermItem>;
export const schemaTermItem = z.object({
  id: z.number().nullable(),
  uid: z.string(),
  teamId: z.number(),
  name: z.string(),
  description: z.string(),
});

export type TermListItem = z.infer<typeof schemaTermListItem>;
export const schemaTermListItem = z.object({
  id: z.number().nullable(),
  uid: z.string(),
  teamId: z.number(),
  name: z.string(),
  description: z.string(),
});

export const toItem = (term: Term): TermItem => {
  return {
    id: term.id,
    uid: term.uid,
    teamId: term.teamId,
    name: term.name,
    description: term.description,
  };
};

export const toListItem = (term: Term): TermListItem => {
  return {
    id: term.id,
    uid: term.uid,
    teamId: term.teamId,
    name: term.name,
    description: term.description,
  };
};
